export const getSessionStorage = (name: string) => {
  const storage = sessionStorage.getItem(name);
  return storage && JSON.parse(storage);
};

export const setSessionStorage = (name: string, dataParams: string) => {
  dataParams && sessionStorage.setItem(name, JSON.stringify(dataParams));
};
export const deleteSessionStorage = (name: string) => {
  sessionStorage.removeItem(name);
};

export const checkAndUpdateSessionStorage = (
  sessionStorage: any,
  updatedSessionFromApi: string
) => {
  if (sessionStorage !== updatedSessionFromApi) {
    setSessionStorage('_session', updatedSessionFromApi);
  }
};
